module.exports = __webpack_public_path__ + "static/media/google-calendar.c1378bb1.png";